import { createFileRoute } from '@tanstack/react-router';
import { LogoLink } from '@/components/logo-link';
import { LoginForm } from './-components/login-form';

export const Route = createFileRoute('/_auth/sign-in/')({
  component: SignInComponent,
  head: () => ({
    meta: [{ title: 'FeatureBuddy - Sign In' }],
  }),
});

function SignInComponent() {
  return (
    <div className="flex flex-col gap-6">
      <LogoLink />
      <LoginForm />
      <div className="text-muted-foreground *:[a]:hover:text-primary text-center text-xs text-balance *:[a]:underline *:[a]:underline-offset-4">
        By clicking continue, you agree to our{' '}
        <a target="blank" href="https://featurebuddy.com/terms/">
          Terms of Service
        </a>{' '}
        and{' '}
        <a target="blank" href="https://featurebuddy.com/policy/">
          Privacy Policy
        </a>
        .
      </div>
    </div>
  );
}
